<script setup lang="ts">
import { useAnalytics } from '../../composables/useAnalytics'

/**
 * Props for FormFallbackCTA
 * @prop buttonText - Text for the CTA button (required)
 * @prop formUrl - URL to the fallback form (required)
 * @prop location - CTA location for analytics (optional, e.g., 'hero', 'mid', 'footer')
 * @prop product - Product context for analytics (optional, e.g., 'review', 'verify', 'insight')
 * @prop fallbackReason - Reason for fallback (optional, for analytics)
 */
const props = defineProps<{
  buttonText: string
  formUrl: string
  location?: string
  product?: string
  fallbackReason?: string
}>()

const emit = defineEmits(['cta_clicked'])

const { emitCTAClicked } = useAnalytics()

function handleClick() {
  // Track CTA click via shared composable (consistent schema)
  emitCTAClicked(props.location || 'mid', props.product || 'unknown', props.buttonText, 'form')

  emit('cta_clicked', {
    location: props.location || '',
    product: props.product || '',
    buttonText: props.buttonText,
    destination: props.formUrl,
    fallbackReason: props.fallbackReason || '',
    timestamp: new Date().toISOString(),
  })
}
</script>

<template>
  <div class="form-fallback-cta">
    <UButton
      :to="props.formUrl"
      @click="handleClick"
    >
      {{ props.buttonText }}
    </UButton>
  </div>
</template>

<style scoped>
.form-fallback-cta {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2rem 0;
}
</style>
